import * as types from '../const/action.types';
import { post } from '../api/_basic';

export function reportsEmployeeIsLoading(bool) {
    return {
        type: types.REPORT_EMPLOYEE_IS_LOADING,
        isLoading: bool,
    };
}

export function reportsEmployeeFieldsFetchDataSuccess(items) {
    return {
        type: types.REPORT_EMPLOYEE_FETCH_DATA,
        items,
    };
}

export function loadEmployee(employee, from, to) {
    return async (dispatch) => {
        dispatch(
            reportsEmployeeFieldsFetchDataSuccess({
                from: from,
                idTrabajador: employee,
                to: to,
            }),
        );
        dispatch(reportsEmployeeIsLoading(true));
        try {
            const body = {
                desde: from,
                hasta: to,
                idTrabajador: employee,
            };
            const response = await post(`${process.env.REACT_APP_API_REPORT_EMPLOYEE}`, body);
            dispatch(reportsEmployeeIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            dispatch(reportsEmployeeFieldsFetchDataSuccess(response));
        } catch (error) {
            dispatch(reportsEmployeeIsLoading(false));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.reports.employee.actions.js